export enum InformationBoxTheme {
  Clean = 'clean',
  WithOutline = 'withOutline',
}
